import React, { useState } from "react";
import "./ResetPasswordRequest.css";
import { useNavigate } from "react-router-dom";

const ResetPasswordRequest = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/')
  }

  const handleResetRequest = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_RESET_PASSWORD_REQUEST, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (data.status === "success") {
        setMessage(data.message);
        setError("");
      } else {
        setError(data.message);
        setMessage("");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
      setMessage("");
    }
  };

  return (
<div className="main-div">
<div className="reset-password-container">
      <h2>Reset Password</h2>
      <input
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <button onClick={handleResetRequest}>Send Reset Link</button>
      {message && <p className="success">{message}</p>}
      {error && <p className="error">{error}</p>}
      <button
  onClick={handleClick}
  style={{ marginTop: "5px" }}
  className="bg-blue-500 text-white px-4 py-2 rounded"
>
  Go to Home
</button>

    </div>
</div>
  );
};

export default ResetPasswordRequest;
